import { ipadLogsApi } from '_/services/api';
import { useMediaPipeStore } from '_/store/useMediaPipeStore';
import { useEffect } from 'react';

export function MediaPipeInitializer() {
  const initMediaPipe = useMediaPipeStore((s) => s.init);

  useEffect(() => {
    ipadLogsApi.insert({
      type: '[MediaPipe] initialization triggered',
      message: 'Inicialização do MediaPipe acionada.',
    });
    initMediaPipe();
  }, []);

  return null;
}
